import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';

const FeaturesSection = (props) => {
    const { SectionTitleShow = true } = props;
    
    return (
        <div className={"" +props.hclass} style={{ paddingTop: '40px' }}>
            <div className="container">
                {SectionTitleShow && (
                    <div className="row" style={{ marginTop: '0', marginBottom: '30px' }}>
                        <SectionTitle subtitle={'Nos Avantages'} title={'Pourquoi'} titleColor={'Nous Choisir'} />
                    </div>
                )}
                <div className="row justify-content-center align-items-stretch">
                    <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="wpo-features-item" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div className="wpo-features-icon" style={{ alignSelf: 'center', marginBottom: '20px', float: 'none' }}>
                                <i className="fi flaticon-car"></i>
                            </div>
                            <div className="wpo-features-text" style={{ textAlign: 'center', overflow: 'visible' }}>
                                <h2>Technologie Avancée</h2>
                                <p>Équipements de pointe pour l'extrusion et la transformation d'aluminium. Innovation constante dans nos processus de production.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="wpo-features-item" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div className="wpo-features-icon" style={{ alignSelf: 'center', marginBottom: '20px', float: 'none' }}>
                                <i className="fi flaticon-24-hours-support"></i>
                            </div>
                            <div className="wpo-features-text" style={{ textAlign: 'center', overflow: 'visible' }}>
                                <h2>Support Client 24/7</h2>
                                <p>Assistance technique et commerciale disponible pour répondre à tous vos besoins en aluminium industriel.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="wpo-features-item" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div className="wpo-features-icon" style={{ alignSelf: 'center', marginBottom: '20px', float: 'none' }}>
                                <i className="fi flaticon-smile"></i>
                            </div>
                            <div className="wpo-features-text" style={{ textAlign: 'center', overflow: 'visible' }}>
                                <h2>Ingénieurs Experts</h2>
                                <p>Équipe d'experts en aluminium avec une expertise reconnue dans l'extrusion et la transformation industrielle.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeaturesSection;